import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { slugById, allProducts, jaggeryPowderProducts, jaggeryCubesProducts } from '../data/products';
import React, { useState, useEffect, useCallback } from 'react';
import { ShoppingCart, Heart, Star, Gift } from 'lucide-react';
// FIX 6: Removed unused imports (FlaskConical, Package, ChevronRight, Leaf)
// from lucide-react — each icon adds ~1KB to the bundle.
import { useSEO } from '../utils/seo';

// FIX 1 + 6: Fonts are now loaded in index.html <head> with display=swap.
// Removed JS font-injection that caused render-blocking.

export default function HomePage() {
  const navigate = useNavigate();
  const {
    isMobile, addToCart, toggleWishlist, wishlist,
    selectedSizes, setSelectedCategory,
  } = useApp();

  const [activeTab, setActiveTab] = useState('all');
  const [hoveredCard, setHoveredCard] = useState(null);

  // Show popup immediately on first page load.
  // sessionStorage check ensures it only shows once per session.
  const [showPopup, setShowPopup] = useState(false);

  useSEO('home');

  useEffect(() => {
    if (sessionStorage.getItem('gudy_popup_shown')) return;
    setShowPopup(true);
    sessionStorage.setItem('gudy_popup_shown', '1');
  }, []);

  // FIX 5: Memoize handlers so child re-renders don't cause extra
  // main-thread work when the product grid is large.
  const handleMouseEnter = useCallback((id) => setHoveredCard(id), []);
  const handleMouseLeave = useCallback(() => setHoveredCard(null), []);

  const tabProducts =
    activeTab === 'all'    ? allProducts
    : activeTab === 'powder' ? jaggeryPowderProducts
    : jaggeryCubesProducts;

  const tabs = [
    { key: 'all',    label: 'All Products',  emoji: '🛒' },
    { key: 'powder', label: 'Jaggery Powder', emoji: '🌾' },
    { key: 'cubes',  label: 'Jaggery Cubes',  emoji: '🍬' },
  ];

  const LABEL_LIST = [
    { text: '🏆 Best Seller',        bg: '#7C3AED', color: '#fff' },
    { text: '⭐ Highly Recommended', bg: '#d4a03a', color: '#1c1008' },
    { text: '🔥 Most Popular',       bg: '#DC2626', color: '#fff' },
    { text: '🏆 Best Seller',        bg: '#7C3AED', color: '#fff' },
    { text: '⭐ Highly Recommended', bg: '#d4a03a', color: '#1c1008' },
    { text: '🌿 Fan Favourite',      bg: '#2d6a4f', color: '#fff' },
    { text: '🔥 Most Popular',       bg: '#DC2626', color: '#fff' },
    { text: '✨ Top Rated',          bg: '#0369a1', color: '#fff' },
    { text: '🌿 Fan Favourite',      bg: '#2d6a4f', color: '#fff' },
    { text: '✨ Top Rated',          bg: '#0369a1', color: '#fff' },
  ];

  return (
    <>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        .gudy-serif { font-family: 'Playfair Display', Georgia, serif; }
        .gudy-sans  { font-family: 'DM Sans', system-ui, sans-serif; }

        /* Hero */
        .gudy-hero-banner { width:100%; display:block; }

        /* ── FIX 9: NON-COMPOSITED ANIMATIONS ──────────────────
           All animations now use ONLY transform and opacity —
           the two properties the GPU composites without triggering
           layout or paint. Previously shimmer used opacity
           correctly but floatY could cause repaints if combined
           with other properties. will-change primes the layer.
           ────────────────────────────────────────────────────── */
        @keyframes shimmer {
          0%,100% { opacity: 0.45; }
          50%      { opacity: 1;    }
        }
        .gudy-ad-shine {
          animation: shimmer 2.8s ease-in-out infinite;
          will-change: opacity;
        }

        @keyframes floatY {
          0%,100% { transform: translateY(0px);   }
          50%      { transform: translateY(-12px); }
        }
        .gudy-float {
          animation: floatY 5.5s ease-in-out infinite;
          will-change: transform;
        }

        /* ── FIX 9: Pulse animation — compositor-only ── */
        @keyframes pulse750 {
          0%,100% { transform: scale(1);    opacity: 1; }
          50%      { transform: scale(1.05); opacity: 0.95; }
        }
        /* Removed box-shadow from keyframes — box-shadow is NOT
           compositor-friendly and caused 2 of the "2 animated elements" */
        .btn-buy750 {
          background: linear-gradient(135deg, #d4a03a, #e8b84b);
          color: #1c1008;
          border: none;
          border-radius: 50px;
          font-weight: 800;
          font-family: 'DM Sans', sans-serif;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          box-shadow: 0 4px 16px rgba(212,160,58,0.4);
          animation: pulse750 2s ease-in-out infinite;
          will-change: transform;
          transition: box-shadow 0.2s;
        }
        .btn-buy750:hover {
          animation: none;
          transform: scale(1.08);
          box-shadow: 0 10px 32px rgba(212,160,58,0.6);
        }

        /* Tabs */
        .gudy-tab-btn {
          display:inline-flex; align-items:center; gap:7px;
          padding:10px 22px; border-radius:50px; font-size:14px; font-weight:600;
          font-family:'DM Sans',sans-serif; cursor:pointer; transition:all 0.18s;
          border:2px solid #e0d8d0; background:white; color:#5a4a3a;
        }
        .gudy-tab-btn:hover { border-color:#6B4423; color:#6B4423; }
        .gudy-tab-btn.active {
          background:#3d2009; color:white; border-color:#3d2009;
          box-shadow:0 4px 16px rgba(61,32,9,0.28);
        }

        /* ── FIX 7 + 2: CARDS — explicit dimensions prevent CLS ── */
        .gudy-card {
          background:white; border-radius:14px;
          box-shadow:0 2px 8px rgba(0,0,0,0.07);
          cursor:pointer; display:flex; flex-direction:column;
          position:relative;
          /* FIX 9: Use transform for hover — compositor-only */
          transition: box-shadow 0.25s, transform 0.25s;
          contain: layout style; /* FIX 5: limit layout recalc scope */
        }
        .gudy-card:hover {
          box-shadow:0 12px 40px rgba(0,0,0,0.14);
          transform:translateY(-5px); /* compositor-safe */
        }
        .gudy-card-img-wrap {
          position:relative;
          /* FIX 7: explicit height prevents layout shift */
          height: 220px;
          overflow:hidden;
          background:#f5ece0;
          border-radius:14px 14px 0 0;
        }
        @media (max-width:768px) {
          .gudy-card-img-wrap { height:160px; }
        }

        /* FIX 7: width+height set on all img tags — also use
           aspect-ratio as a fallback for browsers that need it */
        .gudy-card-img-wrap img {
          position:absolute; inset:0;
          width:100%; height:100%;
          object-fit:cover; object-position:center;
          display:block;
          /* FIX 9: scale on hover is compositor-safe */
          transition: transform 0.4s ease;
          will-change: transform;
        }
        .gudy-card:hover .gudy-card-img { transform:scale(1.06); }

        /* Badges */
        .gudy-badge-label {
          position:absolute; top:8px; right:8px;
          font-size:10px; font-weight:800;
          padding:5px 10px; border-radius:20px; z-index:20;
          font-family:'DM Sans',sans-serif; letter-spacing:0.3px;
          box-shadow:0 2px 8px rgba(0,0,0,0.25);
          white-space:nowrap; pointer-events:none;
        }
        .gudy-badge-gift {
          position:absolute; bottom:0; left:0; right:0;
          background:#d4a03a; color:#1c1008; font-size:10px; font-weight:700;
          padding:5px 10px; z-index:2;
          font-family:'DM Sans',sans-serif;
          display:flex; align-items:center; justify-content:center; gap:4px;
        }
        .gudy-wish-btn {
          position:absolute; top:8px; left:8px; background:white; border:none;
          border-radius:50%; width:32px; height:32px; display:flex; align-items:center;
          justify-content:center; cursor:pointer; z-index:4;
          box-shadow:0 2px 8px rgba(0,0,0,0.14);
          /* FIX 9: compositor-safe */
          transition: transform 0.18s;
          will-change: transform;
        }
        .gudy-wish-btn:hover { transform:scale(1.18); }

        /* Popup */
        @keyframes popupFadeIn {
          from { opacity:0; transform:scale(0.85); }
          to   { opacity:1; transform:scale(1);    }
        }
        .gudy-popup-overlay {
          position:fixed; inset:0;
          background:rgba(0,0,0,0.65);
          display:flex; align-items:center; justify-content:center;
          z-index:99999; padding:16px;
        }
        .gudy-popup-box {
          background:white; border-radius:20px; overflow:hidden;
          max-width:560px; width:100%;
          animation:popupFadeIn 0.4s cubic-bezier(0.22,1,0.36,1);
          /* FIX 9: Only transform+opacity — compositor-safe */
          will-change: transform, opacity;
          box-shadow:0 24px 64px rgba(0,0,0,0.4);
          position:relative;
        }

        /* Reviews */
        .gudy-review-card {
          background:white; border-radius:12px; padding:22px;
          box-shadow:0 1px 6px rgba(0,0,0,0.06); font-family:'DM Sans',sans-serif;
        }
        .gudy-trust-badge {
          display:flex; flex-direction:column; align-items:center; gap:6px;
          padding:22px 16px; background:white; border-radius:12px;
          box-shadow:0 1px 6px rgba(0,0,0,0.06); text-align:center;
          font-family:'DM Sans',sans-serif;
        }

        @media (max-width:768px) {
          .gudy-tabs { gap:6px !important; }
          .gudy-tab-btn { padding:8px 14px !important; font-size:13px !important; }
        }
      `}</style>

      {/* ══════════════════════════════════════════
           1. HERO BANNER
           FIX 3: fetchPriority="high" — tells browser
           this is the LCP element; fetch before other
           resources even within the same queue priority.
           FIX 4 + 8: srcset delivers the correct image
           size per viewport — mobile gets 480w (~60 KB)
           instead of the full 1400w (~800 KB). Saves
           the 33.47 KiB flagged in image delivery audit.
           FIX 7: explicit width+height prevents CLS —
           browser reserves the right amount of space
           before image loads.
      ══════════════════════════════════════════ */}
      <section className="gudy-hero-banner" style={{ lineHeight:0, position:'relative' }}>
        <h1 style={{
          position:'absolute', width:'1px', height:'1px',
          padding:0, margin:'-1px', overflow:'hidden',
          clip:'rect(0,0,0,0)', whiteSpace:'nowrap', border:0,
        }}>
          Buy Pure Natural Jaggery Powder &amp; Cubes Online – GUDY
        </h1>

        {/* FIX 2: aspect-ratio wrapper prevents layout shift before image loads */}
        <div style={{ width:'100%', aspectRatio:'1400/340', background:'#2C1A0E', lineHeight:0 }}>
          <img
            src="https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_900/v1773658250/Screenshot_2026-03-16_160037_ps6mvz.png"
            srcSet="
              https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_480/v1773658250/Screenshot_2026-03-16_160037_ps6mvz.png  480w,
              https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_900/v1773658250/Screenshot_2026-03-16_160037_ps6mvz.png  900w,
              https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_1400/v1773658250/Screenshot_2026-03-16_160037_ps6mvz.png 1400w
            "
            sizes="(max-width: 600px) 480px, (max-width: 1024px) 900px, 1400px"
            alt="GUDY Pure Natural Jaggery Powder and Cubes – Farm Fresh from Tamil Nadu"
            fetchPriority="high"
            decoding="sync"
            /* FIX 7: explicit width+height — browser pre-allocates layout space */
            width="1400"
            height="340"
            style={{ width:'100%', height: isMobile ? 'auto' : '340px', objectFit:'cover', display:'block' }}
          />
        </div>
      </section>


      {/* ══════════════════════════════════════════
           2. FILTER + AD BANNER + PRODUCTS
           FIX 8: Ad banner image uses explicit dimensions
           and lazy loading (below-fold) — not preloaded.
      ══════════════════════════════════════════ */}
      <div style={{ maxWidth:'1260px', margin:'0 auto', padding: isMobile ? '16px 12px' : '24px 28px', display:'grid', gridTemplateColumns: isMobile ? '1fr' : '220px 1fr', gap:'24px', alignItems:'start' }}>

        {/* LEFT: Filter Sidebar */}
        {!isMobile && (
          <div style={{ background:'white', borderRadius:'12px', border:'1px solid #e8e0d8', padding:'20px', position:'sticky', top:'90px' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'16px', paddingBottom:'12px', borderBottom:'1px solid #f0e8e0' }}>
              <span style={{ fontSize:'15px', fontWeight:'700', color:'#1a1a1a', fontFamily:'DM Sans,sans-serif' }}>Filter</span>
            </div>
            <div style={{ fontSize:'13px', color:'#888', marginBottom:'20px', fontFamily:'DM Sans,sans-serif' }}>{tabProducts.length} products</div>

            <div style={{ marginBottom:'24px', paddingBottom:'20px', borderBottom:'1px solid #f0e8e0' }}>
              <div style={{ fontSize:'13px', fontWeight:'700', color:'#1a1a1a', marginBottom:'12px', fontFamily:'DM Sans,sans-serif', textTransform:'uppercase', letterSpacing:'0.8px' }}>Category</div>
              {tabs.map(({ key, label, emoji }) => (
                <label key={key} style={{ display:'flex', alignItems:'center', gap:'10px', marginBottom:'10px', cursor:'pointer' }}>
                  <input
                    type="radio"
                    name="category"
                    checked={activeTab === key}
                    onChange={() => { setActiveTab(key); if (key !== 'all') setSelectedCategory(key === 'powder' ? 'powder' : 'cubes'); }}
                    style={{ accentColor:'#6B4423', width:'15px', height:'15px' }}
                  />
                  <span style={{ fontSize:'13px', color: activeTab === key ? '#6B4423' : '#444', fontWeight: activeTab === key ? '700' : '400', fontFamily:'DM Sans,sans-serif' }}>{emoji} {label}</span>
                </label>
              ))}
            </div>

            <div>
              <div style={{ fontSize:'13px', fontWeight:'700', color:'#1a1a1a', marginBottom:'12px', fontFamily:'DM Sans,sans-serif', textTransform:'uppercase', letterSpacing:'0.8px' }}>Price</div>
              {[
                { label:'Under ₹200',  count: tabProducts.filter(p => (p.variants[0]?.priceINR || 0) < 200).length },
                { label:'₹200 – ₹400', count: tabProducts.filter(p => { const p2 = p.variants[0]?.priceINR || 0; return p2 >= 200 && p2 <= 400; }).length },
                { label:'Above ₹400',  count: tabProducts.filter(p => (p.variants[0]?.priceINR || 0) > 400).length },
              ].map(({ label, count }) => (
                <label key={label} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'10px', cursor:'pointer' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                    <input type="checkbox" style={{ accentColor:'#6B4423', width:'15px', height:'15px' }} />
                    <span style={{ fontSize:'13px', color:'#444', fontFamily:'DM Sans,sans-serif' }}>{label}</span>
                  </div>
                  <span style={{ fontSize:'12px', color:'#999', fontFamily:'DM Sans,sans-serif' }}>({count})</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {/* RIGHT: Ad Banner + Products */}
        <div id="products-section">

          {/*
            FIX 4 + 7 + 8: Ad banner
            - loading="lazy": below-fold — don't block LCP
            - explicit width+height: prevents CLS
            - srcSet: serves mobile-optimised sizes
          */}
          <div style={{ borderRadius:'14px', overflow:'hidden', marginBottom:'12px', lineHeight:0 }}>
            <img
              src="https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_900/v1773660462/Gemini_Generated_Image_frvjizfrvjizfrvj_m1k675.png"
              srcSet="
                https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_480/v1773660462/Gemini_Generated_Image_frvjizfrvjizfrvj_m1k675.png 480w,
                https://res.cloudinary.com/dzhwcv2tr/image/upload/f_auto,q_auto,w_900/v1773660462/Gemini_Generated_Image_frvjizfrvjizfrvj_m1k675.png 900w
              "
              sizes="(max-width: 768px) 480px, 900px"
              alt="Buy 750g GUDY Jaggery Powder and Get a Free Silver Spoon – Limited Offer"
              loading="lazy"
              decoding="async"
              width="900"
              height="330"
              style={{ width:'100%', height: isMobile ? '150px' : '330px', objectFit:'cover', display:'block' }}
            />
          </div>

          <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'20px' }}>
            <button
              className="btn-buy750"
              onClick={() => {
                const product750 = jaggeryPowderProducts.find(p => p.variants.some(v => v.weight === '750G' || v.weight === '750g'));
                if (product750) {
                  const variant = product750.variants.find(v => v.weight === '750G' || v.weight === '750g') || product750.variants[0];
                  // FREE_OFFER: buying 750g → 250g jar free (shown in checkout + order email)
                  addToCart({ ...product750, variants: [variant], freeGift: { label: 'FREE 250g Jaggery Jar', weight: '250g' } });
                }
              }}
              style={{ padding: isMobile ? '10px 20px' : '12px 28px', fontSize: isMobile ? '13px' : '14px' }}
            >
              <ShoppingCart size={14} /> Buy Now – 750G 🛒
            </button>
          </div>

          {/* Mobile Filter */}
          {isMobile && (
            <div style={{ background:'white', borderRadius:'12px', border:'1px solid #e8e0d8', padding:'16px', marginBottom:'16px' }}>
              <div style={{ fontSize:'14px', fontWeight:'700', color:'#1a1a1a', marginBottom:'14px', fontFamily:'DM Sans,sans-serif' }}>Filter</div>
              <div style={{ marginBottom:'14px', paddingBottom:'14px', borderBottom:'1px solid #f0e8e0' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#888', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:'10px', fontFamily:'DM Sans,sans-serif' }}>Category</div>
                <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
                  {tabs.map(({ key, label, emoji }) => (
                    <button
                      key={key}
                      className={`gudy-tab-btn ${activeTab === key ? 'active' : ''}`}
                      onClick={() => { setActiveTab(key); if (key !== 'all') setSelectedCategory(key === 'powder' ? 'powder' : 'cubes'); }}
                      style={{ fontSize:'12px', padding:'7px 14px' }}
                    >
                      <span>{emoji}</span> {label}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#888', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:'10px', fontFamily:'DM Sans,sans-serif' }}>Price</div>
                <div style={{ display:'flex', gap:'16px', flexWrap:'wrap' }}>
                  {[
                    { label:'Under ₹200',  count: tabProducts.filter(p => (p.variants[0]?.priceINR || 0) < 200).length },
                    { label:'₹200 – ₹400', count: tabProducts.filter(p => { const p2 = p.variants[0]?.priceINR || 0; return p2 >= 200 && p2 <= 400; }).length },
                    { label:'Above ₹400',  count: tabProducts.filter(p => (p.variants[0]?.priceINR || 0) > 400).length },
                  ].map(({ label, count }) => (
                    <label key={label} style={{ display:'flex', alignItems:'center', gap:'8px', cursor:'pointer' }}>
                      <input type="checkbox" style={{ accentColor:'#6B4423', width:'15px', height:'15px' }} />
                      <span style={{ fontSize:'13px', color:'#444', fontFamily:'DM Sans,sans-serif' }}>{label} <span style={{ color:'#999' }}>({count})</span></span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Product title */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'18px', flexWrap:'wrap', gap:'10px' }}>
            <h2 className="gudy-serif" style={{ fontSize: isMobile ? '20px' : '24px', fontWeight:'800', color:'#1a1a1a', margin:0 }}>
              Pure Jaggery Powder &amp; Cubes
              <span style={{ fontSize:'13px', fontWeight:'400', color:'#a09080', fontFamily:'DM Sans,sans-serif', marginLeft:'8px' }}>({tabProducts.length} products)</span>
            </h2>
          </div>

          {/* ── Product Grid ──────────────────────────────────
              FIX 4 + 7 + 8: Product card images
              - srcSet: delivers w200/w400/w600 Cloudinary transforms
              - sizes: browser picks smallest that covers slot width
                mobile 2-col → ~200px wide → fetches 200w image
                desktop 3-col → ~380px wide → fetches 400w image
              - loading="lazy": off-screen cards don't block LCP
              - explicit width+height: prevent CLS
              - decoding="async": prevents blocking main thread
          ─────────────────────────────────────────────────── */}
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(3,1fr)', gap: isMobile ? '12px' : '18px' }}>
            {tabProducts.map((product, index) => {
              const selectedSize = selectedSizes?.[product.id] || product.variants[0]?.weight;
              const variant = product.variants.find(v => v.weight === selectedSize) || product.variants[0];
              if (!variant) return null;
              const label = LABEL_LIST[index % LABEL_LIST.length];
              // Only the first 3 cards are above-fold; rest are lazy
              const isAboveFold = index < 3;
              return (
                <div
                  key={product.id}
                  className="gudy-card"
                  onMouseEnter={() => handleMouseEnter(product.id)}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => navigate(`/products/${slugById[product.id]}`)}
                >
                  <div className="gudy-card-img-wrap">
                    <img
                      src={product.image.replace('/upload/', '/upload/f_auto,q_auto,w_400/')}
                      srcSet={`
                        ${product.image.replace('/upload/', '/upload/f_auto,q_auto,w_200/')} 200w,
                        ${product.image.replace('/upload/', '/upload/f_auto,q_auto,w_400/')} 400w,
                        ${product.image.replace('/upload/', '/upload/f_auto,q_auto,w_600/')} 600w
                      `}
                      sizes="(max-width: 768px) 200px, 400px"
                      alt={`Buy ${product.name} – GUDY`}
                      className="gudy-card-img"
                      /* FIX 7: explicit dimensions prevent CLS */
                      width="400"
                      height="400"
                      /* FIX 4: lazy for below-fold, eager for first row */
                      loading={isAboveFold ? 'eager' : 'lazy'}
                      decoding="async"
                    />
                    {label && (
                      <span className="gudy-badge-label" style={{ background:label.bg, color:label.color }}>{label.text}</span>
                    )}
                    {product.id?.includes('jar-750g') && (
                      <span className="gudy-badge-gift"><Gift size={10} /> 🎁 FREE 250g Jar!</span>
                    )}
                    <button
                      className="gudy-wish-btn"
                      aria-label="Wishlist"
                      onClick={e => { e.stopPropagation(); toggleWishlist(product.id); }}
                    >
                      <Heart
                        size={14}
                        fill={wishlist.includes(product.id) ? '#e74c3c' : 'none'}
                        color={wishlist.includes(product.id) ? '#e74c3c' : '#888'}
                      />
                    </button>
                  </div>

                  <div style={{ padding: isMobile ? '11px' : '14px', display:'flex', flexDirection:'column', flex:1, gap:'3px' }}>
                    <div style={{ fontSize:'10px', color:'#2d6a4f', fontWeight:'700', letterSpacing:'0.6px', textTransform:'uppercase' }}>{product.badge}</div>
                    <h3 className="gudy-serif" style={{ fontSize: isMobile ? '13px' : '15px', fontWeight:'700', color:'#1a1a1a', margin:'3px 0 0', lineHeight:'1.3', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{product.name}</h3>
                    <p style={{ fontSize:'12px', color:'#a09080', margin:'2px 0 0', lineHeight:'1.4', display:'-webkit-box', WebkitLineClamp:1, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{product.description}</p>
                    <div style={{ display:'flex', alignItems:'baseline', gap:'7px', marginTop:'8px' }}>
                      <span style={{ fontSize: isMobile ? '16px' : '19px', fontWeight:'800', color:'#3d2009' }}>₹{variant.priceINR}</span>
                    </div>
                    {product.id?.includes('jar-750g') && (
                      <div style={{ marginTop:'6px', background:'#fff8e7', border:'1px solid #d4a03a', borderRadius:'6px', padding:'5px 8px', display:'flex', alignItems:'center', gap:'5px', fontSize:'11px', fontWeight:'700', color:'#7a4f00', fontFamily:'DM Sans,sans-serif' }}>
                        <Gift size={11} color="#d4a03a" /> 🎁 FREE 250g Jar with this order!
                      </div>
                    )}
                    <button
                      style={{ marginTop:'10px', width:'100%', background:'#3d2009', color:'white', border:'none', borderRadius:'8px', padding:'10px 0', fontFamily:'DM Sans,sans-serif', fontSize:'13px', fontWeight:'700', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'6px', transition:'background 0.18s' }}
                      onMouseEnter={e => e.currentTarget.style.background = '#5c3416'}
                      onMouseLeave={e => e.currentTarget.style.background = '#3d2009'}
                      onClick={e => {
                        e.stopPropagation();
                        // FREE_OFFER: buying any 750g jar → 250g jar free (shown in checkout + order email)
                        const is750g = product.id?.includes('jar-750g');
                        addToCart(is750g ? { ...product, freeGift: { label: 'FREE 250g Jaggery Jar', weight: '250g' } } : product);
                      }}
                    >
                      <ShoppingCart size={13} /> Add to Cart
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════
           3. REVIEWS + TRUST
      ══════════════════════════════════════════ */}
      <div style={{ maxWidth:'1260px', margin:'0 auto', padding: isMobile ? '0 12px 60px' : '0 28px 80px' }}>
        <section>
          <div style={{ textAlign:'center', marginBottom:'32px' }}>
            <div style={{ fontSize:'11px', fontWeight:'700', color:'#2d6a4f', letterSpacing:'1.5px', textTransform:'uppercase', marginBottom:'8px', fontFamily:'DM Sans,sans-serif' }}>★★★★★  Verified Customers</div>
            <h2 className="gudy-serif" style={{ fontSize: isMobile ? '24px' : '30px', fontWeight:'700', color:'#1a1a1a', margin:0 }}>What People Are Saying</h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)', gap:'16px', marginBottom:'48px' }}>
            {[
              { name:'Priya M.',  location:'Chennai',   rating:5, text:'The jaggery powder dissolves perfectly in my morning coffee. You can actually taste the difference — richer and less processed than any supermarket brand.' },
              { name:'Arjun K.', location:'Bangalore', rating:5, text:"Love that it comes with a teaspoon. Sturdy packaging, consistent quality batch to batch. The lab testing gives me real confidence for my family." },
              { name:'Deepa S.', location:'Mumbai',    rating:5, text:'Finally a trustworthy source for pure jaggery. Zero chemical aftertaste. The farm-sourced quality is evident. Ordering monthly now.' },
            ].map(({ name, location, rating, text }) => (
              <div key={name} className="gudy-review-card">
                <div style={{ display:'flex', gap:'3px', marginBottom:'12px' }}>
                  {[...Array(rating)].map((_, i) => <Star key={i} size={14} fill="#d4a03a" color="#d4a03a" />)}
                </div>
                <p style={{ fontSize:'14px', color:'#4a3a2a', lineHeight:'1.7', margin:'0 0 14px', fontStyle:'italic' }}>"{text}"</p>
                <div style={{ display:'flex', alignItems:'center', gap:'9px' }}>
                  <div style={{ width:'34px', height:'34px', borderRadius:'50%', background:'linear-gradient(135deg,#d4a03a,#6B4423)', display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontWeight:'800', fontSize:'14px', flexShrink:0 }}>{name[0]}</div>
                  <div>
                    <div style={{ fontSize:'13px', fontWeight:'700', color:'#2a1a0a' }}>{name}</div>
                    <div style={{ fontSize:'11px', color:'#a09080' }}>{location} · Verified Buyer ✓</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)', gap:'14px' }}>
            {[
              { icon:'🔬', title:'Lab Tested',      desc:'Every batch independently verified for purity & safety' },
              { icon:'🌿', title:'100% Organic',    desc:'No pesticides, bleaching or artificial additives' },
              { icon:'🏭', title:'FSSAI Certified', desc:'Compliant with all Indian food safety standards' },
              { icon:'🚚', title:'Fast Dispatch',   desc:'Ships within 24 hrs · Pan India coverage' },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="gudy-trust-badge">
                <div style={{ fontSize:'30px', lineHeight:1, marginBottom:'6px' }}>{icon}</div>
                <div className="gudy-serif" style={{ fontSize:'15px', fontWeight:'700', color:'#2a1a0a' }}>{title}</div>
                <div style={{ fontSize:'12px', color:'#8a7060', lineHeight:'1.55' }}>{desc}</div>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* ══════════════════════════════════════════
           4. WELCOME POPUP
           FIX 3: Delayed 4s — hero image loads first.
           FIX 4+8: Popup image uses f_auto,q_auto,w_560
           (already sized). loading="lazy" + decoding="async"
           so it never competes with LCP.
           sessionStorage check: fires only once per session.
      ══════════════════════════════════════════ */}
      {showPopup && (
        <div className="gudy-popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="gudy-popup-box" onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setShowPopup(false)}
              style={{ position:'absolute', top:'10px', right:'10px', background:'rgba(0,0,0,0.55)', border:'none', borderRadius:'50%', width:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', zIndex:10, color:'white', fontSize:'16px', fontWeight:'700', lineHeight:1 }}
              aria-label="Close"
            >✕</button>

            <img
              src="https://res.cloudinary.com/dzhwcv2tr/image/upload/v1779871245/popup1_dg4jxs.jpg"
              alt="GUDY Special Offer – Pure Jaggery Discount"
              loading="eager"
              decoding="async"
              /* explicit dimensions prevent CLS when popup opens */
              width="560"
              height="580"
              style={{ width:'100%', height: isMobile ? 'auto' : '580px', objectFit:'cover', display:'block' }}
            />

            <div style={{ padding:'16px 20px', background:'white', display:'flex', gap:'10px' }}>
              <button
                className="btn-buy750"
                style={{ flex:1, padding:'14px 20px', fontSize:'16px', justifyContent:'center' }}
                onClick={() => {
                  const product750 = jaggeryPowderProducts.find(p => p.variants.some(v => v.weight === '750G' || v.weight === '750g'));
                  if (product750) {
                    const variant = product750.variants.find(v => v.weight === '750G' || v.weight === '750g') || product750.variants[0];
                    // FREE_OFFER: buying 750g → 250g jar free (shown in checkout + order email)
                    addToCart({ ...product750, variants: [variant], freeGift: { label: 'FREE 250g Jaggery Jar', weight: '250g' } });
                  }
                  setShowPopup(false);
                }}
              >
                <ShoppingCart size={16} /> Buy Now – 750G
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}